import Vue from 'vue'
import Vuex from 'vuex'
import jp from "jsonpath"
import apiService from "../services/APIService"
import axios from 'axios';
import { sortByProperty } from '../util/common'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    selectedProcess: null,
    processesLoading: false,
    processContentLoading: false,
    processData: [],
    processContent: null,
    manufacturerInfos: [],
    occupationalSafetyPosts: [],
    ownManufacturerInfos: [],
    rootProcesses: [],
    posts: [],
    userPost: [],
    jwtToken: '',
    isLoading: true,
  },
  getters: {
    getPostById: (state) => (id) => {
      return jp.query(state.posts, `$..posts[?(@.id==${id})]`)[0];
    },
    getChildProcesses: (state) => (process) => {
      if(!process) {
        return []
      }
      return jp.query(state.processData, `$..[?(@.parent=='${process.id}')]`)
    },
    processById: (state) => (id) => {
      return jp.query(state.processData, `$..[?(@.id=='${id}')]`)[0]
    },
    processBySlug: (state) => (id) => {
      return jp.query(state.processData, `$..[?(@.slug=='${id}')]`)[0]
    },
    isLoggedIn(state) {
      return state.jwtToken && state.jwtToken.length > 0
    },
    hasManufacturerInfos(state) {
      return state.manufacturerInfos ? state.manufacturerInfos.length > 0 : false
    },
    hasOccupationalSafetyPosts(state) {
      return state.occupationalSafetyPosts ? state.occupationalSafetyPosts.length > 0 : false
    }
  },
  mutations: {
    initStore(state) {
      const token = localStorage.getItem('updateJwtToken')
      state.jwtToken = token
    },
    updateSelectedProcess(state, process) {
      state.selectedProcess = process
    },
    processesLoading(state) {
      state.processesLoading = true
    },
    processesLoadingDone(state) {
      state.processesLoading = false
    },
    processContentLoading(state) {
      state.processContentLoading = true;
    },
    processContentLoadingDone(state) {
      state.processContentLoading = false;
    },
    updateProcessContent(state, content) {
      state.processContent = content
    },
    updateProcesses(state, processData ) {
      state.processData = processData;
      state.rootProcesses = jp.query(processData, `$..[?(@.parent=='0')]`);
    },
    updatePosts(state, posts) {
      state.posts = posts;
    },
    updatePostData(state, post) {
      state.posts = { posts: state.posts.posts.map(p =>  p.id === post.id ?  { ...post } : p) }
    },
    deletePostData(state, postId) {
      state.posts = state.posts.filter(p => p.id !== postId)
    },
    updateJwtToken(state, jwtToken) {
      state.jwtToken = jwtToken
    },
    updateOwnManufacturerInfos(state, infos) {
      state.ownManufacturerInfos = infos.sort(sortByProperty('title'))
    },
    createManufacturerInfo(state, info) {
      if(state.ownManufacturerInfos) {
        state.ownManufacturerInfos.push(info)
        state.ownManufacturerInfos =state.ownManufacturerInfos.sort(sortByProperty('title'))
      }
    },
    updateManufacturerInfo(state, info) {
      if(state.manufacturerInfo && state.manufacturerInfo.id === info.id) {
        state.manufacturerInfo = info
      }
      if(state.ownManufacturerInfos) {
        let ownManufacturerInfos = state.ownManufacturerInfos.map((_info) => _info.id === info.id ? info : _info)
        state.ownManufacturerInfos = ownManufacturerInfos.sort(sortByProperty('title'))
      }
    },
    deleteManufacturerInfo(state, info) {
      if(state.manufacturerInfo) {
        state.manufacturerInfo = state.manufacturerInfo.filter((_info) => _info.id !== info.id)
      }
      let ownManufacturerInfos = state.ownManufacturerInfos.filter((_info) => _info.id !== info.id)
      state.ownManufacturerInfos = ownManufacturerInfos.sort(sortByProperty('title'))
    },
    updateManufacturerInfos(state, infos) {
      state.manufacturerInfos = infos.sort(sortByProperty('title'))
    },
    updateOccupationalSafetyPosts(state, posts) {
      state.occupationalSafetyPosts = posts.sort(sortByProperty('title'))
    },
    updateIsLoading(state, isLoading) {
      state.isLoading = isLoading
    }
  },
  actions: {
    loadProcesses({ commit }) {
      commit('processesLoading');
      apiService.getProcesses().then(processes => {
        commit('updateProcesses', processes)
        commit('processesLoadingDone')
      })
    },
    fetchOwnManufacturerPosts({ commit }) {
      apiService.getOwnManufacturePosts().then((infos) => {
        commit("updateOwnManufacturerInfos", infos)
      })
    },
    updateSelectedProcess({ commit }, process) {
      if(process === undefined) {
        return
      }
      commit('updateSelectedProcess', process);

      commit('processContentLoading')
      axios.all([
          apiService.getProcessContentByProcessId(process.id),
          apiService.getProcessPosts(process.id, 'herstellerinfo'),
          apiService.getProcessPosts(process.id, 'as-info')]).then(result => {
        commit('updateProcessContent', result[0].data);

        commit('updateManufacturerInfos', result[1].data);
        commit('updateOccupationalSafetyPosts', result[2].data);
        commit('processContentLoadingDone')
      })
    },
    createManufacturerInfo({ commit }, info) {
      return apiService.createManufacturerInfo(info).then( _info => {
        commit('createManufacturerInfo', _info)
      })
    },

    updateManufacturerInfo({ commit }, newInfo) {
      return apiService.updateManufacturerInfo(newInfo)
          .then((info) => {
            console.log("Info Response", info)
            commit("updateManufacturerInfo", info)
          })
    },

    deleteManufacturerInfo({ commit }, info) {
      apiService.deleteManufacturerInfo(info).then(() => {
        commit("deleteManufacturerInfo", info)
      })
    },

    updateJwtToken({commit}, data) {
      commit('updateJwtToken', data)
    },
  },
  modules: {
  }
})
store.subscribe((mutation) => {
  if(mutation.type === 'updateJwtToken') {
    localStorage.setItem('updateJwtToken', mutation.payload)
  }
})
export default store
